// Tela de apresentação (LP) dos produtos SaaS — card 86akr879k.
//
// Na primeira vez, o clique no menu mostra a LP do produto DENTRO do Gestão (rota do produto,
// com a página do app novo num iframe). Quem marcou "Não exibir esta página novamente" entra
// direto no produto, em aba nova, como antes.
//
// A escolha é do usuário e fica no app novo (tabela UsuarioTutoriais). O menu precisa saber a
// resposta ANTES do clique: o window.open do produto só passa pelo bloqueador de popup dentro do
// handler do clique, então não dá para perguntar ao servidor na hora. Por isso o sidenav consulta
// ao carregar o menu e guarda; e a LP avisa por postMessage quando o usuário dispensa.
//
// Acrescentar um produto (Vende, Inteligência) é uma linha aqui + a apresentação no app novo.

import Axios from 'axios'

// Instância própria, SEM os interceptors globais do main.js: esta consulta roda em segundo plano
// ao carregar o menu, e lá um 401 desloga o usuário e um 503 mostra toast mesmo com
// skipGlobalErrorNotification. Uma falha aqui não pode custar nada além de mostrar a LP.
// withCredentials como o $httpCookiesOnly: o UpfyGate autentica pelo cookie de sessão.
const http = Axios.create({
  withCredentials: true,
  headers: { Accept: 'application/json' }
})

// link do item de menu (vem da auth) -> chave do módulo (a mesma do gate no app novo)
export const APRESENTACOES = {
  '/seguranca': 'SEGFY_SEGURANCA',
  '/mensagem': 'SEGFY_MENSAGEM',
  '/inteligencia': 'SEGFY_INTELIGENCIA'
}

// Mensagem que a LP (app novo) manda para cá quando o usuário dispensa a apresentação.
export const MENSAGEM_DISPENSADA = 'segfy-apresentacao-dispensada'

/**
 * A LP ainda deve aparecer para o usuário logado? Pelo UpfyGate (rota genérica prd-upfy, que
 * valida a sessão e repassa a identidade ao app novo).
 *
 * Falha ABERTA: erro de rede/servidor responde true — o pior caso é mostrar a LP, nunca impedir
 * o acesso ao produto (a LP tem o botão que leva até ele).
 */
export function consultarApresentacao (chaveModulo) {
  const base = (process.env.VUE_APP_UPFYGATE || '').replace(/\/$/, '')
  if (!base) {
    return Promise.resolve(true)
  }
  return http
    .get(`${base}/prd-upfy/api/apresentacao/${encodeURIComponent(chaveModulo)}`)
    .then((resp) => !(resp.data && resp.data.exibir === false))
    .catch(() => true)
}

/**
 * A mensagem veio mesmo da LP do app novo? Confere a origem: qualquer página aberta em iframe
 * pode mandar postMessage para cá.
 */
export function ehDispensaDaApresentacao (evento) {
  let origemAppNovo
  try {
    origemAppNovo = new URL(process.env.VUE_APP_NEW_SERVER).origin
  } catch (e) {
    return false
  }
  const dados = evento && evento.data
  return evento.origin === origemAppNovo &&
    !!dados && dados.tipo === MENSAGEM_DISPENSADA &&
    // Só produto que tem apresentação: o sidenav grava a chave como recebida.
    Object.values(APRESENTACOES).includes(dados.chaveModulo)
}
